/* ATLAS PDP carousel.
   Progressive enhancement over a native scroll-snap track: with no script the
   track is already swipeable and every image is reachable. This adds arrows,
   a counter, thumbnail sync, keyboard control and a lightbox.

   Touch is never intercepted, so the browser keeps arbitrating horizontal pan
   against vertical page scroll and a sideways swipe cannot trap the page. */
(function () {
  'use strict';
  if (window.__atlasPdp) return;
  window.__atlasPdp = true;
  document.documentElement.classList.add('at-js');

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function gallery(root) {
    var track = $('[data-gal-track]', root);
    var slides = $$('[data-gal-slide]', root);
    var thumbs = $$('[data-gal-thumb]', root);
    var prev = $('[data-gal-prev]', root), next = $('[data-gal-next]', root);
    var zoom = $('[data-gal-zoom]', root), count = $('[data-gal-count]', root);
    var live = $('[data-gal-live]', root);
    if (!track || slides.length < 2) return;
    var i = 0;

    function paint() {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (live) live.textContent = 'Image ' + (i + 1) + ' of ' + slides.length + '. ' + (slides[i].getAttribute('data-label') || '');
    }

    function go(n, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft,
                       behavior: (smooth && !RM.matches) ? 'smooth' : 'auto' });
      paint();
      var t = thumbs[i];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    /* The track is the source of truth: whatever the reader swiped to wins. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var n = slides.indexOf(e.target);
            if (n > -1 && n !== i) { i = n; paint(); }
          }
        });
      }, { root: track, threshold: [0.61] });
      slides.forEach(function (s) { io.observe(s); });
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function (e) { e.preventDefault(); go(n, true); });
    });
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1, true); }
      else if (e.key === 'Home') { e.preventDefault(); go(0, true); }
      else if (e.key === 'End') { e.preventDefault(); go(slides.length - 1, true); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(i); }
    });

    /* Desktop drag, mouse only: touch keeps the native scroller. */
    var down = false, sx = 0, sl = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; moved = Math.abs(dx); track.scrollLeft = sl - dx;
    });
    function end() {
      if (!down) return; down = false;
      var w = slides[0].getBoundingClientRect().width || 1;
      go(Math.round(track.scrollLeft / w), true);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    if (zoom) zoom.addEventListener('click', function () { openLb(i); });
    slides.forEach(function (s, n) {
      var img = s.querySelector('img');
      if (img) img.addEventListener('click', function () { if (moved <= 6) openLb(n); });
    });

    function openLb(n) { if (window.__atlasGlb) window.__atlasGlb(slides[n]); }
    paint();
  }

  /* Lightbox: focus trap, focus return, scroll lock, Escape to close. */
  function lightbox() {
    var lb = $('[data-gal-lb]');
    if (!lb) return;
    var img = lb.querySelector('img');
    var close = $('[data-gal-lb-close]', lb), scrim = $('[data-gal-lb-scrim]', lb);
    var last = null;

    function open(slide) {
      var src = slide.getAttribute('data-full') || slide.querySelector('img').currentSrc;
      last = document.activeElement;
      img.src = src;
      img.alt = slide.querySelector('img').alt;
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    }
    function shut() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      img.removeAttribute('src');
      if (last && last.focus) last.focus();
    }
    close.addEventListener('click', shut);
    if (scrim) scrim.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.stopPropagation(); shut(); return; }
      if (e.key !== 'Tab') return;
      var f = [scrim, close].filter(Boolean);
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
    window.__atlasGlb = open;
  }

  function boot() { lightbox(); $$('[data-gal]').forEach(gallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
